import { cva, VariantProps } from 'class-variance-authority';
import { HTMLAttributes } from 'react';

const spinnerClassNames = cva(
    'tw-box-border tw-aspect-square tw-inline-block tw-animate-spin tw-rounded-full tw-border-0 tw-border-solid tw-border-r-transparent tw-border-t-[2px] tw-border-r-[2px]',
    {
        variants: {
            color: {
                currentColor: 'tw-border-current',
                success: 'tw-border-success',
                error: 'tw-border-error',
                warning: 'tw-border-warning',
                light: 'tw-border-accents-6'
            },
            size: {
                auto: 'tw-min-h-full',
                xs: 'tw-size-3',
                sm: 'tw-size-4',
                md: 'tw-size-5',
                lg: 'tw-size-6',
                xl: 'tw-size-8'
            }
        },
        defaultVariants: {
            size: 'md',
            color: 'currentColor'
        }
    }
);

interface Props
    extends Omit<HTMLAttributes<HTMLSpanElement>, keyof VariantProps<typeof spinnerClassNames>>,
        VariantProps<typeof spinnerClassNames> {}

const Spinner = ({ color, size, className, ...props }: Props) => {
    return <span className={spinnerClassNames({ color, size, className })} {...props} />;
};

export type { Props as SpinnerProps };
export default Spinner;
